import { render } from "./EmojiCard.vue?vue&type=template&id=43aef046&scoped=true"
import script from "./EmojiCard.vue?vue&type=script&lang=js"
export * from "./EmojiCard.vue?vue&type=script&lang=js"

import "./EmojiCard.vue?vue&type=style&index=0&id=43aef046&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43aef046"]])

export default __exports__